/**
 * Countdown timer for [data-countdown-target] elements (a future ISO
 * timestamp), rendering into child [data-countdown-hours/minutes/seconds].
 * Mirrors TrialPackBanner.tsx's useCountdown().
 */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function tick(el, target) {
    var remaining = Math.max(0, target - Date.now());
    var totalSeconds = Math.floor(remaining / 1000);
    var hours = el.querySelector('[data-countdown-hours]');
    var minutes = el.querySelector('[data-countdown-minutes]');
    var seconds = el.querySelector('[data-countdown-seconds]');
    if (hours) hours.textContent = pad(Math.floor(totalSeconds / 3600));
    if (minutes) minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
    if (seconds) seconds.textContent = pad(totalSeconds % 60);
  }

  document.querySelectorAll('[data-countdown-target]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown-target')).getTime();
    if (isNaN(target)) return;
    tick(el, target);
    setInterval(function () { tick(el, target); }, 1000);
  });
})();
